(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('announcement-bar [data-country-toggle]');
  const dropdown = document.querySelector('announcement-bar [data-country-dropdown]');

  if (!toggle || !dropdown) return;

  let isOpen = false;
  let placeholder = document.createElement('div');

  toggle.addEventListener('click', () => {
    if (!isOpen) {
      const rect = toggle.getBoundingClientRect();

      // Insert placeholder to preserve layout
      dropdown.parentNode.insertBefore(placeholder, dropdown);

      // Move dropdown to body
      dropdown.style.position = 'absolute';
      dropdown.style.zIndex = '9999';
      dropdown.style.minWidth = `${toggle.offsetWidth}px`;
      dropdown.style.top = `${rect.bottom + window.scrollY}px`;
      dropdown.style.left = `${rect.left + window.scrollX}px`;
      dropdown.style.visibility = 'visible';
      dropdown.style.opacity = '1';
      document.body.appendChild(dropdown);

      isOpen = true;
      toggle.setAttribute('aria-expanded', 'true');

      // Add listener to close
      document.addEventListener('click', handleOutsideClick);
      window.addEventListener('scroll', closeDropdown, true);
      window.addEventListener('resize', closeDropdown);
    } else {
      closeDropdown();
    }
  });

  function handleOutsideClick(e) {
    if (!dropdown.contains(e.target) && !toggle.contains(e.target)) {
      closeDropdown();
    }
  }

  function closeDropdown() {
    if (!isOpen) return;

    // Restore dropdown to original location
    placeholder.parentNode.insertBefore(dropdown, placeholder);
    placeholder.remove();

    dropdown.style.position = '';
    dropdown.style.zIndex = '';
    dropdown.style.minWidth = '';
    dropdown.style.top = '';
    dropdown.style.left = '';

    isOpen = false;
    toggle.setAttribute('aria-expanded', 'false');

    document.removeEventListener('click', handleOutsideClick);
    window.removeEventListener('scroll', closeDropdown, true);
    window.removeEventListener('resize', closeDropdown);
  }
});


  } catch(e) { console.error(e); }
})();
})();
